module.exports = __webpack_public_path__ + "img/box-middle-long.48324d79.svg";